<template>
    <div class="house-tree-content">
        <div class="main-tree">
            <!--<div class="children-account-title">-->
                <!--<i class="el-icon-location-outline"></i>-->
                <!--我的房源-->
            <!--</div>-->
            <el-input class="input" placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
            <el-tree :data="maintree"
                     :props="defaultProps"
                     node-key="id"
                     :default-expanded-keys="keyArr"
                     :default-checked-keys="keyArr"
                     highlight-current
                     @node-click="handleNodeClick"
                     accordion :filter-node-method="filterNode"
                     ref="tree"></el-tree>
        </div>
        <div class="children-account-manage" v-if="isChild==0">
            <div class="children-account-title" @click="showOrHideAccountList();showchildren=!showchildren">
                <i class="el-icon-location-outline"></i>
                授权账号房源管理
            </div>
            <el-collapse-transition>
                <ul class="children-account-content" v-show="showAccount">
                    <li class="children-account-item transition-box" v-for="(childItem, index) in childItems" @click="ChildrenTree(childItem.Userid,index)">
                        <span v-show="showaccount!=index">{{childItem.Nick}}</span>
                        <el-tree :data="childrentree" :props="defaultProps" @node-click="handleNodeClick" accordion highlight-current v-show="treeindex == index" ></el-tree>
                    </li>
                </ul>
            </el-collapse-transition>
            <!--<transition name="el-zoom-in-bottom">-->
                <!--<div v-show="showchildren" class="transition-box">-->
                    <!--<ul class="children-account-content" v-show="showAccount">-->
                        <!--<li class="children-account-item transition-box" v-for="(childItem, index) in childItems" @click="ChildrenTree(childItem.Userid,index)">-->
                            <!--<span v-show="showaccount!=index">{{childItem.Nick}}</span>-->
                            <!--<el-tree :data="childrentree" :props="defaultProps" @node-click="handleNodeClick" v-if="treeindex == index"></el-tree>-->
                        <!--</li>-->
                    <!--</ul>-->
                <!--</div>-->
            <!--</transition>-->
        </div>
    </div>
</template>

<script>
    import store from "../store";
    export default {
        name: "HouseTree",
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val);
            }
        },
        data() {
            return {
                isChild: window.localStorage.isChild,
                keyArr: [],
                activeName: '1',
                filterText:"",
                maintree: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                childItems: [],
                showAccount: false,
                clickCount: 0,
                childrentree:[],
                showaccount:500,
                treeindex:500,
                showchildren:false,
            };
        },
        mounted: function () {
            this.createTree();
            this.$http.get(`${store.state.url}zone/permissions/${window.localStorage.userid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                .then((res) => {
                    if (res.Code == 0) {
                        this.childItems = res.Data
                    }
                    else {
                        this.$message(res.Message);
                    }
                })
            setTimeout(() => {
                let val = store.state.treeZoneid;
                this.keyArr = [];
                this.keyArr.push(val);
            }, 1000);
        },
        methods: {
            createTree() {
                var userid=window.localStorage.userid;
                this.Housedata(userid).then((housedata)=>{
                    this.maintree=housedata;
                });
            },
            showOrHideAccountList() {
                this.clickCount++;
                if (this.clickCount % 2 == 0) {
                    this.showAccount = false
                } else {
                    this.showAccount = true
                }
            },
            Housedata(userid) {
                return new Promise((resolve, reject)=> {
                    this.$http.get(`${store.state.url}zone/tree/` + userid + `?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                var housedata = [];
                                var data = res.Data;
                                for (let i in data) {
                                    housedata[i] = {id: data[i].Zoneid, label: data[i].Title, children: [], zoneid: data[i].Zoneid, district: data[i].Districtcode, code: data[i].Code};
                                    if (data[i].Children != null) {
                                        for (let j in data[i].Children) {
                                            housedata[i].children[j] = {
                                                id: data[i].Children[j].Zoneid,
                                                label: data[i].Children[j].Title,
                                                children: [],
                                                zoneid: data[i].Children[j].Zoneid,
                                                district: data[i].Children[j].Districtcode,
                                                code: data[i].Children[j].Code
                                            };

                                            let villages = data[i].Children[j].Children
                                            if (villages != null) {
                                                for (let k in villages) {
                                                    housedata[i].children[j].children[k] = {
                                                        id: villages[k].Zoneid,
                                                        label: villages[k].Title,
                                                        children: [],
                                                        zoneid: villages[k].Zoneid,
                                                        district: villages[k].Districtcode,
                                                        code: villages[k].Code
                                                    };

                                                    if (villages[k].Children != null) {
                                                        for (let q in villages[k].Children) {
                                                            housedata[i].children[j].children[k].children[q] = {
                                                                id: villages[k].Children[q].Zoneid,
                                                                label: villages[k].Children[q].Title,
                                                                children: [],
                                                                zoneid: villages[k].Children[q].Zoneid,
                                                                district: villages[k].Children[q].Districtcode,
                                                                code: villages[k].Children[q].Code
                                                            };

                                                            let floors = villages[k].Children[q].Children
                                                            if (floors != null) {
                                                                for (let p in floors) {
                                                                    housedata[i].children[j].children[k].children[q].children[p] = {
                                                                        id: floors[p].Zoneid,
                                                                        label: floors[p].Title,
                                                                        children: [],
                                                                        zoneid: floors[p].Zoneid,
                                                                        district: floors[p].Districtcode,
                                                                        code: floors[p].Code
                                                                    }

                                                                    if (floors[p].Children != null) {
                                                                        for (let t in floors[p].Children) {
                                                                            housedata[i].children[j].children[k].children[q].children[p].children[t] = {
                                                                                id: floors[p].Children[t].Zoneid,
                                                                                label: floors[p].Children[t].Title,
                                                                                children: [],
                                                                                zoneid: floors[p].Children[t].Zoneid,
                                                                                district: floors[p].Children[t].Districtcode,
                                                                                code: floors[p].Children[t].Code
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                resolve(housedata);
                            } else {
                                this.$message(res.Message);
                            }
                        })
                })
            },

            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            handleNodeClick(data) {
                var zoneid=data.zoneid;
                store.commit('assignGetZoneid',zoneid);
                store.commit('assignGetTreedata',data);

                this.$emit('show')
            },
            ChildrenTree(userid,index){
                this.treeindex = index;
                this.showaccount=index;
                this.Housedata(userid).then((housedata)=>{
                    this.childrentree=housedata;
                });
            },
        }
    }
</script>

<style scoped>
    .main-tree {
        margin:0 0.05rem;
        width: 97%;
    }
    .house-tree-content{
        margin-right: 0.2vw;
        margin-bottom: 0.2rem;
    }
    .input{
        margin-bottom: 0.03rem;
    }
    .children-account-manage {
        width: 97%;
        margin:0.05rem;
        font-size: 0.13rem;
        /*padding-left: 0rem;*/
        color: #86888e;
    }
    .children-account-title {
        font-size: 0.16rem;
        margin: 0.2rem 0 0.1rem 0.05rem;
        color: #161616;
        cursor: pointer;
    }
    .children-account-manage .children-account-title i {
        margin-right: 0.02rem;
    }
    .children-account-manage .children-account-content span{
        padding-left: 0.3rem;
    }
    .children-account-content .children-account-item {
        margin-bottom: 0.08rem;
        cursor:pointer;
    }
    .children-account-item span:hover{
        color:#409EFF;
    }
    .el-icon-location-outline{
        color:#67C23A;
        margin-right: 0.06rem;
    }
    .children-account-title:hover{
        color:#67C23A;
    }
</style>
